import Component, { type ImageProps } from "@client/content/controls/Image/component";
import { setSizeToMediaUrl } from "@client/lib/media";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import * as React from "react";
import { makeImageContainer } from "./factory";

const ImageEntity = makeImageContainer(TargetSelector.Entity);

export { ImageEntity };

export interface ContentImageContainerProps {
  alt?: string | null;
  className?: string;
  isFixedSize?: boolean;
  size: string;
  src: string;
  style?: React.CSSProperties;
}

const mapStateToProps =
  () =>
  (state: AppState, { src, ...props }: ContentImageContainerProps): ImageProps => ({
    ...props,
    src: setSizeToMediaUrl(src, props.size)
  });

export default connectCustom(mapStateToProps)(Component);
